import React, { useEffect, useState } from 'react';
interface MacroBreakdownProps {
  protein: number;
  carbs: number;
  fats: number;
}
interface MacroBarProps {
  label: string;
  value: number;
  max: number;
  color: string;
  delay: number;
}
function MacroBar({
  label,
  value,
  max,
  color,
  delay
}: MacroBarProps) {
  const [width, setWidth] = useState(0);
  const percentage = Math.round(value / max * 100);
  useEffect(() => {
    const timer = setTimeout(() => {
      setWidth(value / max * 100);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, max, delay]);
  return <div className="mb-6 last:mb-0" data-id="element-50">
      <div className="flex items-center justify-between mb-2" data-id="element-51">
        <span className="text-gray-300 font-medium" data-id="element-52">{label}</span>
        <span className="text-gray-400 text-sm" data-id="element-53">
          {value}g ({percentage}%)
        </span>
      </div>
      <div className="w-full bg-gray-700 rounded-full h-3 overflow-hidden" data-id="element-54">
        <div className={`h-full rounded-full transition-all duration-700 ease-out ${color}`} style={{
        width: `${width}%`
      }} data-id="element-55" />
      </div>
    </div>;
}
export function MacroBreakdown({
  protein,
  carbs,
  fats
}: MacroBreakdownProps) {
  const total = protein + carbs + fats;
  return <div className="bg-gray-800 rounded-xl p-6 border border-gray-700" data-id="element-56">
      <h2 className="text-xl font-bold text-white mb-6" data-id="element-57">Macros Breakdown</h2>
      <MacroBar label="Protein" value={protein} max={total} color="bg-green-500" delay={100} data-id="element-58" />
      <MacroBar label="Carbs" value={carbs} max={total} color="bg-blue-500" delay={200} data-id="element-59" />
      <MacroBar label="Fats" value={fats} max={total} color="bg-orange-500" delay={300} data-id="element-60" />
    </div>;
}